import React, { useState, useEffect } from "react"
import { sun, moon } from '../Files/icons/index.js';
import {EnglishLang, GermanLang} from "../Files/svg_icons/index.js";

function ThemeSwitcher(props) {

    const [langIcon, setLangIcon] = useState("");
    const [themeIcon, setThemeIcon] = useState(null);

    const themeBtnClick = (val) => {

        props.triggerTheme(val);
    }
    const switchLanguage = (val) => {
        props.switchCurrentLanguage(val);
    }

    useEffect(() => {
        props.activeLanguage === "english" ? setLangIcon("EN") : setLangIcon("DE");
    }, []);

    return (
        <>



            <div className="theme-switch-component">

                <div className="theme-buttons">



                    {
                        props.activeLanguage === "english" ?
                            <button 
                                className="theme-button lang" 
                                onClick={() => switchLanguage("german")}
                                onMouseOver={() => setLangIcon("DE")}
                                onMouseOut={() => setLangIcon("EN")}
                                title="Click to change language"
                            >
                                
                                {/* {langIcon || "EN"} */}
                                {<img src={langIcon === "EN" ? EnglishLang : GermanLang} alt="language" /> }

                            </button> :

                            <button 
                                className="theme-button lang" 
                                onClick={() => switchLanguage("english")}
                                onMouseOver={() => setLangIcon("EN")}
                                onMouseOut={() => setLangIcon("DE")}
                                title="Click to change language"
                            >
                                {<img src={langIcon === "EN" ? EnglishLang : GermanLang} alt="language" /> }
                            </button>
                    }

                    {props.activeTheme === "light" ?

                        <button 
                            className="theme-button" 
                            onClick={() => themeBtnClick("dark")}
                            onMouseOver ={() => setThemeIcon(moon)}
                            onMouseOut={() => setThemeIcon(sun)}
                            title="Click to change theme"
                        >
                            <img src={themeIcon || sun} alt="light" />
                        </button> :

                        <button 
                            className="theme-button" 
                            onClick={() => themeBtnClick("light")}
                            onMouseOver ={() => setThemeIcon(sun)}
                            onMouseOut={() => setThemeIcon(moon)}
                            title="Click to change theme"
                        >
                            <img src={themeIcon || moon} alt="dark" />
                        </button>

                    }

                </div>


            </div>


        </>
    )
}

export default ThemeSwitcher;